<template>
  <div class="page-view">
    <template v-if="Array.isArray(announcements_menu)&&announcements_menu.length">
      <div class="side-menu" :class="{
        'mobile':width<760 
      }">
        <ul class="menu-list">
          <router-link
            class="menu-btn"
            tag="li"
            :to="'/'+lng+'/announcements/actual'"
            active-class="active"
            @click.native="isSelectMenu='actual'"
          >
            <!--  ACTUAL  -->
            <a href="javascript:;">{{t.announcement.actual}}</a>
          </router-link>
          <router-link
            class="menu-btn"
            tag="li"
            :to="'/'+lng+'/announcements/archive/'+announcements_menu[0]"
            :class="{'active': $route.params.type==='archive'}"
            exact
            @click.native="isSelectMenu='archive'"
          >
            <!--  ARCHIVE (Tüm verilerin Tamamını Sayfa oluşurken alıyor.)-->
            <a href="javascript:;">{{t.announcement.archive}}</a>
            <div class="mobile-menu" v-if="width<760&&isSelectMenu==='archive'">
              <button class="diginity dg-left-arrow-thin" id="slide-nav__prev"></button>
              <!--  MOBILE menu (archive) -->
              <swiper class="swiper" ref="menuSwiper" :options="options">
                <swiper-slide v-for="item in announcements_menu" :key="item">
                  <router-link
                    :to="'/'+lng+'/announcements/archive/'+item"
                    active-class="active"
                  >{{ item }}</router-link>
                </swiper-slide>
              </swiper>
              <button class="diginity dg-right-arrow-thin" id="slide-nav__next"></button>
            </div>
            <!--  DESKTOP dropdown (archive) -->
            <ul v-else class="dropdown">
              <li v-for="item in announcements_menu" :key="item">
                <router-link
                  :to="'/'+lng+'/announcements/archive/'+item"
                  active-class="active"
                >{{ item }}</router-link>
              </li>
            </ul>
          </router-link>
        </ul>
      </div>
      <div class="content">
        <!-- page header -->
        <div class="content-header">
          <h3>{{ ($route.params.type === 'actual') ? t.announcement.actual : t.announcement.archive }}</h3>
        </div>
        <!-- Listing content -->
        <div class="content-list">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
          <router-view name="id"></router-view>
        </div>
      </div>
    </template>
    <!-- loading animation for Request  -->
    <template v-else>
      <div class="spinner" v-if="Array.isArray(announcements_menu) && !announcements_menu.length">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <p class="response-error" v-if="announcements_menu==undefined">
        <span>{{ lng == 'tr' ? 'Kayıt bulunamadı' : 'No Records Found' }}</span>
      </p>
    </template>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isSelectMenu: "",
      width: undefined,
      currentYear: new Date().getFullYear(),
      //slider options
      options: {
        slidesPerView: 3,
        navigation: {
          nextEl: "#slide-nav__next",
          prevEl: "#slide-nav__prev"
        },
        breakpoints: {
          400: {
            slidesPerView: 2
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters(["t", "lng", "announcements_menu"])
  },
  async created() {
    this.width = window.innerWidth;
    this.isSelectMenu = this.$route.params.type;
    // Servisten İstekte Bulunma ('language')
    // 'store/Actions.js' see => 'announcements_list'
    this.$store.dispatch("announcements_list");
  },
  mounted() {
    const self = this;
    //windows width dinamik olarak alma (responsive menu için)
    self.$nextTick(() => {
      window.addEventListener("resize", () => {
        self.width = window.innerWidth;
      });
    });
  },
  components: {
    swiper,
    swiperSlide
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/colors";
@import "../styles/announcements_partner";
</style>